import { StorageKey, StorageService, UserPagination } from '@lib/core';
import { UserPaginationService } from '@lib/user';

export class PurchaseRequisitionPagination extends UserPagination {
    public static async restore(
        storage: StorageService,
        paginationService: UserPaginationService
    ): Promise<PurchaseRequisitionPagination> {
        if (await storage.has(StorageKey.PURCHASE_REQUISITION_LIST_PAGINATION)) {
            const storedPagination: string | null = await storage.getItem(
                StorageKey.PURCHASE_REQUISITION_LIST_PAGINATION
            );
            if (storedPagination) {
                const parsedPagination: UserPagination = JSON.parse(storedPagination);
                const restoredPagination = new PurchaseRequisitionPagination(
                    storage,
                    parsedPagination.elementsPerPage,
                    parsedPagination.page,
                    parsedPagination.totalPages,
                    parsedPagination.totalEntries
                );
                await restoredPagination.save();
                return restoredPagination;
            }
        }

        return PurchaseRequisitionPagination.default(storage, paginationService);
    }

    public static async default(
        storage: StorageService,
        paginationService: UserPaginationService
    ): Promise<PurchaseRequisitionPagination> {
        const userPagination = await paginationService.createDefaultPagination();
        const defaultPagination = new PurchaseRequisitionPagination(
            storage,
            userPagination.elementsPerPage,
            userPagination.page,
            userPagination.totalPages,
            userPagination.totalEntries
        );
        await defaultPagination.save();

        return defaultPagination;
    }

    constructor(
        storage: StorageService,
        elementsPerPage: number,
        page: number,
        totalPages: number,
        totalEntries: number
    ) {
        super(storage);
        this.elementsPerPage = elementsPerPage;
        this.page = page;
        this.totalPages = totalPages;
        this.totalEntries = totalEntries;
    }

    public override async save(): Promise<void> {
        await super.save(StorageKey.PURCHASE_REQUISITION_LIST_PAGINATION);
    }
}
